import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user', 'userIsPatient'])
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/computed.js